export const requestNotificationPermission = async (): Promise<
  NotificationPermission | ServiceWorkerRegistration
> => {
  console.log('Requesting notification permission!!!');
  try {
    const notificationPermission = await Notification.requestPermission();
    if (notificationPermission === 'granted') {
      return navigator.serviceWorker.register('/firebase-messaging-sw.js');
    }
    return notificationPermission;
  } catch (error) {
    console.error('Notification => ', error);
  }

  return 'default';
};
